import Button from "components/ui/Button";
import React, { useState } from "react";

const ReferAFriend = () => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      <div className="py-10 text-center leading-5 text-white/70  md:text-[13px] text-[16px] px-8">
        Share your referral link via WhatsApp and social networks with your friends (up to Y) and start winning right now.
      </div>
      <div className="md:h-16 h-14 text-sm rounded-md flex items-center px-3 text-white/30 border border-white/80">Share link</div>
      <div className="pt-3">
        <Button
          label={isLoading ? "Logging in..." : "Generate"}
          type="submit"
          size="small"
          variant="green"
          className="uppercase md:max-w-[350px] w-full"
        />
      </div>
    </>
  );
};
export default ReferAFriend;
